import { foundationListboxOptionStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { ColorHEX, PrimaryRapidColorHEX } from '../_common';
export const zeroListboxOptionStyles = (context, definition) => css `
  ${foundationListboxOptionStyles(context, definition)}
  :host {
    background-color: ${ColorHEX.darkGrey};
    margin: 0;
    border-radius: 0;
    border: 1px solid ${ColorHEX.lightGrey};
  }

  :host(:hover:not([disabled])) {
    background-color: ${ColorHEX.mediumGrey};
  }

  :host(.selected) {
    background-color: ${ColorHEX.darkerGrey};
    color: ${PrimaryRapidColorHEX.blue};
  }
`;
